/*  MUI  */
import { Check } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

/*  Shared  */
import { Token } from 'application/Shared/Requests';

/* Hooks */
import { getUserTheme } from 'hooks/dataAccess/User/userTheme';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

/*  Components  */
import { IntegrationWrapper } from './Components/IntegrationWrapper';

/* Constants */
import IntegrationScriptFilename from './Constants/IntegrationScriptsFilename.json';

/* Helpers */
import { getScript } from './Helpers/utils';

class CWAutomate extends Component {
    constructor(props) {
        super(props);
        this.state = { deploymentSteps: [], hasToken: false };

        /* requests */
        this.Token = new Token();
    }

    componentDidMount() {
        this.load();
    }

    componentWillUnmount() {
        this.unload();
    }

    load = async () => {
        const partnerToken = await this.Token.getToken();

        if (partnerToken) {
            this.setState({ hasToken: true });
            this.setDeploymentSteps(partnerToken);
        }
    };

    unload = () => {
        this.unmount = true;
        this.Token.cancel();
    };

    setDeploymentSteps = async (partnerToken) => {
        const { t } = this.props;

        let appVersion = '1.26.0';
        if (process.env.REACT_APP_VERSION) {
            appVersion = process.env.REACT_APP_VERSION;
        }

        const scriptCopyValue1st = await getScript({
            filename: IntegrationScriptFilename.cwAutomateScript_1_2,
            token: partnerToken
        });

        const scriptCopyValue2nd = await getScript({
            filename: IntegrationScriptFilename.cwAutomateScript_2_2,
            token: partnerToken
        });

        const deploymentSteps = [
            {
                component: (
                    <Typography variant="h4">
                        {t('Integrations.setup_process')}
                    </Typography>
                ),
                step: false
            },
            {
                note: (
                    <Typography
                        dangerouslySetInnerHTML={{
                            __html: t('Integrations.CWAutomate.note1')
                        }}
                    />
                ),
                step: false
            },
            {
                component: t('Integrations.CWAutomate.step1'),
                step: true
            },
            {
                component: `${t('Common.click')}:`,
                step: true,
                stepValue: `+ ${t('Common.add')}`
            },
            {
                component: `${t('Integrations.set_the_target')}:`,
                step: true,
                stepValue: t('Common.computer')
            },
            {
                component: `${t(
                    'Integrations.CWAutomate.configure_isolated_script'
                )}:`,
                step: true,
                stepValue: (
                    <Box display="flex" alignItems="center">
                        {t('Common.checked')}
                        <Check
                            sx={{ color: 'icon.primary', marginLeft: '4px' }}
                        />
                    </Box>
                )
            },
            {
                component: t('Integrations.set_the_name'),
                copyValue: t('Integrations.asm_version', {
                    appVersion
                }),
                step: true
            },
            {
                component: t('Integrations.set_the_notes'),
                copyValue: t('Integrations.CWAutomate.step6', {
                    date: new Date()
                }),
                step: true
            },
            {
                component: (
                    <Box mt="32px">
                        <Typography variant="h4" mb="8px">
                            {t('Integrations.script_code')}
                        </Typography>
                        {t('Integrations.CWAutomate.script_type_help')}
                    </Box>
                ),
                step: false
            },
            {
                note: (
                    <Typography
                        dangerouslySetInnerHTML={{
                            __html: t('Integrations.CWAutomate.note2')
                        }}
                    />
                ),
                step: false
            },
            {
                component: t('Integrations.CWAutomate.step7_8'),
                copyValue: scriptCopyValue1st,
                step: true
            },
            {
                component: t('Integrations.CWAutomate.step7_8'),
                copyValue: scriptCopyValue2nd,
                step: true
            }
        ];

        if (!this.unmount) {
            this.setState({ deploymentSteps });
        }
    };

    render() {
        const { onboarding = false, session, t } = this.props;
        const { hasToken, deploymentSteps } = this.state;
        const userTheme = getUserTheme(session?.user?.theme);

        return (
            <IntegrationWrapper
                hasToken={hasToken}
                deploymentSteps={deploymentSteps}
                headerTitle={t('Integrations.CWAutomate.header')}
                img={`/images/${userTheme}/integrations/cw_automate.png`}
                imgWidth="200px"
                onboarding={onboarding}
            />
        );
    }
}

export default withTranslation()(CWAutomate);
